// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Match register-textbox dimensions: 463px width at 1536 screen = 30.14vw */
.register-select_textbox__EhSK9 {
  width: 30.14vw;
  max-width: 463px;
  min-width: 200px;
  padding: clamp(14px, 1.8vh, 20px) clamp(18px, 1.8vw, 28px);
  border: none;
  border-radius: 50px;
  background: linear-gradient(270deg, #CFE5FF 0%, #FFE5B0 100%);
  color: black;
  font-size: clamp(15px, 1.3vw, 20px);
  cursor: pointer;
}

.register-select_textbox__EhSK9:focus {
  outline: none;
  box-shadow: 0 0 4px 1px #FFE5B0;
}

.register-select_textbox__EhSK9::placeholder {
  color: #9a9a9a;
  opacity: 1;
}

label {
  display: block;
  margin-bottom: 6px;
  margin-left: 20px;
  margin-top: 0;
  font-family: "FreckleFace", serif;
  font-weight: 400;
  font-style: normal;
  color: #FEE5B1;
  font-size: clamp(16px, 1.4vw, 22px);
}

.register-select_label-wrapper__nO5R6 {
  width: 30.14vw;
  max-width: 463px;
  min-width: 200px;
  display: inline-block;
  border: none;
  background: none;
  text-align: left;
}

/* Tablet adjustments */
@media (max-width: 1024px) {

  .register-select_textbox__EhSK9,
  .register-select_label-wrapper__nO5R6 {
    width: 40vw;
    max-width: 350px;
  }

  .register-select_textbox__EhSK9 {
    padding: 14px 18px;
    font-size: 16px;
  }

  label {
    font-size: 16px;
    margin-left: 16px;
  }
}

/* Mobile adjustments */
@media (max-width: 768px) {

  .register-select_label-wrapper__nO5R6,
  .register-select_textbox__EhSK9 {
    width: 100%;
    max-width: 100%;
  }

  .register-select_textbox__EhSK9 {
    padding: 14px 18px;
    font-size: 15px;
  }

  label {
    font-size: 15px;
    margin-left: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/UI/common/Inputs/register-select.module.css"],"names":[],"mappings":"AAAA,4EAA4E;AAC5E;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,0DAA0D;EAC1D,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;;EAEE;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,uBAAuB;AACvB;;EAEE;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/* Match register-textbox dimensions: 463px width at 1536 screen = 30.14vw */\n.textbox {\n  width: 30.14vw;\n  max-width: 463px;\n  min-width: 200px;\n  padding: clamp(14px, 1.8vh, 20px) clamp(18px, 1.8vw, 28px);\n  border: none;\n  border-radius: 50px;\n  background: linear-gradient(270deg, #CFE5FF 0%, #FFE5B0 100%);\n  color: black;\n  font-size: clamp(15px, 1.3vw, 20px);\n  cursor: pointer;\n}\n\n.textbox:focus {\n  outline: none;\n  box-shadow: 0 0 4px 1px #FFE5B0;\n}\n\n.textbox::placeholder {\n  color: #9a9a9a;\n  opacity: 1;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 6px;\n  margin-left: 20px;\n  margin-top: 0;\n  font-family: \"FreckleFace\", serif;\n  font-weight: 400;\n  font-style: normal;\n  color: #FEE5B1;\n  font-size: clamp(16px, 1.4vw, 22px);\n}\n\n.label-wrapper {\n  width: 30.14vw;\n  max-width: 463px;\n  min-width: 200px;\n  display: inline-block;\n  border: none;\n  background: none;\n  text-align: left;\n}\n\n/* Tablet adjustments */\n@media (max-width: 1024px) {\n\n  .textbox,\n  .label-wrapper {\n    width: 40vw;\n    max-width: 350px;\n  }\n\n  .textbox {\n    padding: 14px 18px;\n    font-size: 16px;\n  }\n\n  label {\n    font-size: 16px;\n    margin-left: 16px;\n  }\n}\n\n/* Mobile adjustments */\n@media (max-width: 768px) {\n\n  .label-wrapper,\n  .textbox {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .textbox {\n    padding: 14px 18px;\n    font-size: 15px;\n  }\n\n  label {\n    font-size: 15px;\n    margin-left: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textbox": `register-select_textbox__EhSK9`,
	"label-wrapper": `register-select_label-wrapper__nO5R6`
};
export default ___CSS_LOADER_EXPORT___;
